import type { Analytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyD8ZDPt7HnUGnwdCkGvXLBJacOCAp_BCsQ",
  authDomain: "onemore-asia.firebaseapp.com",
  projectId: "onemore-asia",
  storageBucket: "onemore-asia.firebasestorage.app",
  messagingSenderId: "1060484855726",
  appId: "1:1060484855726:web:484c7bc5beab93f5b73a3f",
  measurementId: "G-1F02ZG3G8E",
};

/**
 * Firebase SDK はまるごと動的 import に逃がしています。
 * このLPが SDK を必要とするのは計測だけで、初期表示を遅らせるとそのまま
 * 離脱につながるためです。非対応環境では null を返し、計測なしで動作を続けます。
 */
let analyticsPromise: Promise<Analytics | null> | null = null;
function getAnalyticsSafe(): Promise<Analytics | null> {
  if (!analyticsPromise) {
    analyticsPromise = (async () => {
      const [{ initializeApp }, analytics] = await Promise.all([
        import("firebase/app"),
        import("firebase/analytics"),
      ]);
      if (!(await analytics.isSupported())) return null;
      return analytics.getAnalytics(initializeApp(firebaseConfig));
    })().catch(() => null);
  }
  return analyticsPromise;
}

/** 計測は失敗しても本体の動作に影響させません */
export async function track(name: string, params?: Record<string, unknown>): Promise<void> {
  try {
    const instance = await getAnalyticsSafe();
    if (!instance) return;
    const { logEvent } = await import("firebase/analytics");
    logEvent(instance, name, params);
  } catch {
    /* 計測できなくても無視します */
  }
}
